/**
 * Created by lihanying on 2017/7/6.
 */

export const GETCLUBINFOS = 'GETCLUBINFOS'
export const GETBANKINFO = 'GETBANKINFO'
export const UPDATE_UNIONPAY_INFO = 'UPDATE_UNIONPAY_INFO'


// WEBPACK FOOTER //
// ./src/containers/ClubInfo/constants.js